import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessIcon from '../../icons/check-circle.svg';

type InputValidationSuccessProps = {
	message?: string;
}

export const InputValidationSuccess = ({ message }: InputValidationSuccessProps) => {
	const { t } = useTranslation();

	return (
		<div className='InputValidation'>
			<img className='InputValidation__Icon' src={SuccessIcon} alt={t('aria.success_icon')}/>

			<div role='status' className="InputValidation__Message InputValidation__Message--success">{message}</div>
		</div>
	);
};
